import React, { Component } from "react";
import "./style.css";
import anime from "animejs/lib/anime.es.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAndroid,
  faConnectdevelop,
  faCss3Alt,
  faHtml5,
  faJava,
  faJs,
  faPython,
  faReact,
  faUnity,
} from "@fortawesome/free-brands-svg-icons";
import Fade from 'react-reveal/Fade'; // Importing Zoom effect

export default class Info extends Component {
  state = { theposition: 0.2, count: 0 };
  move1() {
    var elem = document.querySelectorAll("#myBar");
    var width = 0;
    var id = setInterval(frame, 56);
    var text1 = document.querySelectorAll(".text1");
    elem[0].style.transition = "0.18s";
    elem[1].style.transition = "0.18s";
    elem[2].style.transition = "0.18s";
    function frame() {
      if (width >= 60) {
        clearInterval(id);
      } else {
        width++;
        elem[0].style.width = width + "%";
        elem[1].style.width = width + "%";
        elem[2].style.width = width + 5 + "%";
        text1[0].textContent = `${width}%`;
        text1[1].textContent = `${width}%`;
        text1[2].textContent = `${width + 5}%`;
      }
    }
  }
  move2() {
    var elem = document.getElementById("myBar2");
    var width2 = 0;
    var id = setInterval(frame, 56);
    var text2 = document.querySelector(".text2");
    elem.style.transition = "0.18s";
    function frame() {
      if (width2 >= 45) {
        clearInterval(id);
      } else {
        width2++;
        elem.style.width = width2 + "%";
        text2.textContent = `${width2}%`;
      }
    }
  }
  move3() {
    var elem = document.getElementById("myBar3");
    var width3 = 0;
    var id = setInterval(frame, 56);
    var text3 = document.querySelector(".text3");
    elem.style.transition = "0.18s";
    function frame() {
      if (width3 >= 55) {
        clearInterval(id);
      } else {
        width3++;
        elem.style.width = width3 + "%";
        text3.textContent = `${width3}%`;
      }
    }
  }
  move4() {
    var elem = document.getElementById("myBar4");
    var width4 = 0;
    var id = setInterval(frame, 56);
    var text4 = document.querySelector(".text4");
    elem.style.transition = "0.18s";
    function frame() {
      if (width4 >= 75) {
        clearInterval(id);
      } else {
        width4++;
        elem.style.width = width4 + "%";
        text4.textContent = `${width4}%`;
      }
    }
  }
  move5() {
    var elem = document.getElementById("myBar5");
    var width5 = 0;
    var col = document.querySelector(".col4");
    console.log(col);
    var id = setInterval(frame, 56);
    var text5 = document.querySelector(".text5");
    elem.style.transition = "0.18s";
    function frame() {
      if (width5 >= 60) {
        clearInterval(id);
      } else {
        width5++;
        elem.style.width = width5 + "%";
        text5.textContent = `${width5}%`;
      }
    }
  }

  radiusNone(index) {
    const skills = document.querySelectorAll(".col-skills");

    skills[index].style.borderTopLeftRadius = "0x";
    skills[index].style.borderTopRightRadius = "0";
  }
  radius(index) {
    const skills = document.querySelectorAll(".col-skills");

    skills[index].style.borderTopLeftRadius = "0";
    skills[index].style.borderTopRightRadius = "0";
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.listenToScroll);
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll / height;

    if (this.state.theposition > 0.15) {
      this.setState({ count: this.state.count + 1 });
      if (this.state.count < 2) {
        setTimeout(() => {
          this.animation();
          this.move1();
          this.move2();
          this.move3();
          this.move4();
          this.move5();
          this.opac2();
        }, 400);
      } else {
      }
    }
    this.setState({
      theposition: scrolled,
    });
  };
  opac2() {
    var lets = document.querySelectorAll(".letters");
    lets.forEach((item) => {
      item.style.transition = "0.3s";
      item.style.opacity = "1";
    });
  }
  opac() {
    var lets = document.querySelectorAll(".letters");
    lets.forEach((item) => {
      item.style.opacity = "0";
    });
  }
  animation() {
    var textWrapper = document.querySelectorAll(".ml14 .letters");
    textWrapper.forEach((item) => {
      item.innerHTML = item.textContent.replace(
        /\S/g,
        "<span class='letter'>$&</span>"
      );
    });

    anime
      .timeline({ loop: false })
      .add({
        targets: ".ml14 .line",
        scaleX: [0, 1],
        opacity: [0.5, 1],
        easing: "easeInOutExpo",
        duration: 900,
      })
      .add({
        targets: ".ml14 .letter",
        opacity: [0, 1],
        translateX: [40, 0],
        translateZ: 0,
        scaleX: [0.3, 1],
        easing: "easeOutExpo",
        duration: 800,
        offset: "-=600",
        delay: (el, i) => 150 + 25 * i,
      })
      .add({
        targets: ".ml14",
        opacity: 1,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 2000,
      });
  }

  componentDidMount() {
    this.opac();
    window.addEventListener("scroll", this.listenToScroll);
  }

  render() {
    return (
      
      <div id="exp" className="cont">
        <div className="about text-left">
          <h2 className="exp-title text-left">Experiences</h2>
          <h2 className="text-left exp-title exp-title2">
            Most recent studies
          </h2>
        </div>
        <Fade bottom>
        <div>
          <div className="col1 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">Unity</span>
                <div>
                  <FontAwesomeIcon
                    icon={faUnity}
                    size="3x"
                    className="html_icon"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar" className="w3-green"></div>
            </div>
            <span>
              <p className="text1 text_p text"></p>
            </span>
          </div>
          <div className="col1 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">Java</span>
                <div>
                  <FontAwesomeIcon
                    icon={faJava}
                    size="3x"
                    className="html_icon"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar" className="w3-green"></div>
            </div>
            <span>
              <p className="text1 text_p text"></p>
            </span>
          </div>

          <div className="col1 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">ReactJS</span>
                <div>
                  <FontAwesomeIcon
                    icon={faReact}
                    color="#42cff5"
                    size="3x"
                    className="html_icon"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar" className="w3-green"></div>
            </div>
            <span>
              <p className="text1 text_p text"></p>
            </span>
          </div>
          <div className="col2 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">Python</span>
                <div>
                  <FontAwesomeIcon
                    icon={faPython}
                    size="3x"
                    className="html_icon"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar2" className="w3-green"></div>
            </div>
            <span>
              <p className="text2 text_p text"></p>
            </span>
          </div>

          <div className="col3 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">Javascript</span>
                <div>
                  <FontAwesomeIcon
                    icon={faJs}
                    size="3x"
                    className="html_icon"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar3" className="w3-green"></div>
            </div>
            <span>
              <p className="text3 text_p text"></p>
            </span>
          </div>
          <div className="col5 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">MySQL</span>
                <div>
                  <FontAwesomeIcon
                    icon={faConnectdevelop}
                    size="3x"
                    className="html_icon"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar5" className="w3-green"></div>
            </div>
            <span>
              <p className="text5 text_p text"></p>
            </span>
          </div>
          <div className="col4 col-skills">
            <h1 className="ml14">
              <span className="text-wrapper">
                <span className="letters text">
                  Html <span className="ml-3 mt-3">-</span> Css
                </span>
                <div>
                  <FontAwesomeIcon
                    icon={faHtml5}
                    size="3x"
                    className="html_icon mt-2"
                    color="#dd4b25"
                  />
                  <FontAwesomeIcon
                    icon={faCss3Alt}
                    size="3x"
                    className="html_icon ml-2"
                    color="#249cda"
                  />
                </div>
                <span className="line"></span>
              </span>
            </h1>
            <div className="bg-light progress">
              <div id="myBar4" className="w3-green"></div>
            </div>
            <span>
              <p className="text4 text_p text"></p>
            </span>
          </div>
        </div>
        </Fade>
      </div>
      
      
    );
  }
}
